import * as React from 'react';
import { Spinner } from 'react-bootstrap';

export default class OrdenesDeLiquidaciones extends React.Component {

    render = () => {

        const ordenes = this.props.ordenes;

        return (

            this.props.isLoading ?

            <div className="d-flex justify-content-center">
                <Spinner animation="border" variant="secondary" size="lg-centrado" role="status">
                    <span className="sr-only">Loading...</span>
                </Spinner>
            </div>

            :

            ordenes.length > 0 ?

            <div className="row justify-content-center align-items-center p-10">

                <h5 className="col-auto">Órdenes</h5>

                <div className="list-group-item col-12 animated fadeIn">
                    <div className="table-responsive card">
                        <table className="table">
                            <thead>
                                <tr>
                                    <th scope="col">N° Orden</th>
                                    <th scope="col">Tipo</th>
                                    <th scope="col">Estado</th>
                                    <th scope="col">Fecha</th>
                                    <th scope="col">Importe</th>
                                    <th scope="col">Comisión Neta</th>
                                    <th scope="col">Comisión Total</th>
                                    <th scope="col">Total</th>
                                </tr>
                            </thead>
                            <tbody>
                            {
                                ordenes.map((orden, i) => {
                                    return (
                                        <tr key={i} className="hover-background-color">
                                            <td><small><span>{orden.idOrden}</span></small></td>
                                            <td><small><span>{orden.tipoPublicacion}</span></small></td>
                                            <td><small><span>{orden.descripcionEstado}</span></small></td>
                                            <td><small><span>{orden.fechaOrdenMostrar}</span></small></td>
                                            <td><small><span>${orden.importeOrden}</span></small></td>
                                            <td><small><span>${orden.importeComisionNeta}</span></small></td>
                                            <td><small><span>${orden.importeComisionTotal}</span></small></td>
                                            <td><small><span>${orden.totalOrden}</span></small></td>
                                        </tr>
                                    )
                                })
                            }
                            </tbody>
                        </table>
                    </div>
                </div>

            </div>

            :

            <div className="card">
                <div className="card-body">
                    <div className="row justify-content-center align-items-center p-10">
                        No hay órdenes para esta liquidación
                    </div>
                </div>
            </div>
        );
    }
}